function init() {
  linkFieldInput($('#gift_card_form_buyer_email'), $('#user_email'));
  linkNameInput($('#gift_card_form_buyer_name'), $('#user_first_name'), $('#user_last_name'));
}

function linkFieldInput($emailField1, $emailField2) {
  $emailField1.focusout(function () {
    if ($emailField1.val() && isEmpty($emailField2.val())) {
      $emailField2.val($emailField1.val());
    }
  });
}

function linkNameInput($fullName, $firstName, $lastName) {
  $fullName.focusout(function () {
    if ($fullName.val()) {
      var parts = $fullName.val().split(' ');
      var firstName = parts.shift();
      var lastName = parts.join(' ');
      if (isEmpty($firstName.val()) && isEmpty($lastName.val())) {
        $firstName.val(firstName);
        $lastName.val(lastName);
      }
    }
  });
}

function isEmpty(string) {
  return (!string || 0 === string.length);
}

module.exports = {
  init,
};



// WEBPACK FOOTER //
// ./javascripts/components/legacy/gift_cards/create_account_form.js